/** Terms & Privacy — Français. Actuellement surtout 1:1; groupes, chaînes et modération peuvent suivre. */
export const legalDocumentsFr = {
  termsFull: `1. Acceptation de ces conditions

En créant un compte, en vous connectant ou en utilisant Duvpost (le « Service », « nous »), vous acceptez les présentes conditions d'utilisation. Si vous n'acceptez pas, n'utilisez pas le Service.

2. Qu'est-ce que Duvpost

Duvpost est une application web de messagerie et de communication en temps réel, exploitée à petite échelle.

À ce jour, le produit est centré sur la messagerie temps réel un à un, les pièces jointes, les appels voix/vidéo entre utilisateurs individuels, les salles type Meet par lien, et la découverte/profil (p. ex. recherche People) avec e-mail/mot de passe ou Google. Les conversations de groupe, chaînes et flux de modération dédiés ne sont pas des fonctions obligatoires de la version actuelle, mais peuvent être introduits ultérieurement sans accord séparé ; le cas échéant, les présentes conditions s'appliquent aussi à ces fonctions.

Nous pouvons ajouter, modifier ou retirer des fonctionnalités dans le temps. Toutes les fonctionnalités décrites ne sont pas disponibles dans votre région, sur votre offre ou dans votre version d'application à tout moment.

Le Service utilise Google Firebase (Authentication, Firestore, Storage, Cloud Functions et infrastructure associée) et d'autres composants décrits dans la Politique de confidentialité.

3. Éligibilité

Au moins 16 ans ou l'âge minimum dans votre pays. Mineurs uniquement avec consentement du titulaire de l'autorité parentale. Pas de collecte délibérée de données d'enfants sous l'âge applicable.

4. Votre compte

Informations exactes, identifiants sécurisés, responsabilité de l'activité sous votre compte. En cas de compromission suspectée, nous contacter via les canaux publiés.

Pour les offres payantes (p. ex. « Premium »), les tarifs, cycles de facturation et taxes sont indiqués à l'achat. Le non-paiement peut entraîner une rétrogradation ou la perte de fonctionnalités payantes.

5. Offres, limites de stockage et conservation

Nous pouvons proposer différents niveaux de compte (p. ex. standard/gratuit et payant). Les limites — p. ex. taille maximale de fichier, stockage total, téléversements simultanés ou suppression automatique des pièces jointes après un délai — peuvent varier selon l'offre et changer. Nous nous efforcerons de prévenir des changements importants lorsque raisonnable (p. ex. dans l'application, par e-mail ou conditions mises à jour), sauf obligation légale contraire.

Sur les offres limitées, les fichiers téléversés peuvent être supprimés automatiquement après un délai que nous indiquons ou en cas de dépassement de quotas. Les offres supérieures peuvent offrir des limites plus élevées, une conservation plus longue ou moins de restrictions ; « illimité » reste soumis à une utilisation raisonnable et à des politiques anti-abus.

Vous êtes responsable de vos sauvegardes de données importantes. Le Service actuel conserve les messages et fichiers de discussion 14 jours à compter de leur création, puis les supprime automatiquement. Nous ne garantissons pas un stockage illimité et indéfini du contenu utilisateur.

6. Contenu utilisateur

Vous conservez vos droits sur votre contenu. Vous nous accordez une licence limitée, mondiale et non exclusive pour héberger, stocker, reproduire, transmettre et afficher votre contenu uniquement dans la mesure nécessaire pour exploiter et sécuriser le Service, faire respecter ces conditions et se conformer à la loi — messagerie un à un, appels, Meet, et lorsqu'elles existent, groupes, chaînes et fonctions associées.

Nous ne revendiquons pas la propriété de votre contenu. Le contenu des messages peut être stocké chiffré ; détails dans la Politique de confidentialité. Vous êtes responsable de la légalité et des droits des tiers. Lorsque des groupes ou chaînes existent, la loi et les présentes conditions s'y appliquent également ; nous pouvons publier des règles supplémentaires.

7. Utilisation acceptable

Interdit notamment : utilisation illégale, nuisible, harcelante ou discriminatoire ; malware/phishing ; accès non autorisé ; abus d'API ; usurpation ; violation de la PI ou de la vie privée ; spam ; utilisation de chaînes ouvertes ou découvrables et fonctions similaires, si et lorsqu'elles sont proposées, pour du contenu illégal.

Nous pouvons suspendre l'accès ou supprimer ou restreindre du contenu lorsque la loi ou ces conditions l'exigent. Nous n'avons pas l'obligation générale de surveiller toutes les communications ; si nous introduisons des outils de signalement ou de modération, leur utilisation ne garantit pas de délais de réponse ni de résultats particuliers.

8. Appels et infrastructure tierce

Voix/vidéo (y compris appels de groupe si nous les ajoutons) : médias P2P ou relais (TURN). Les opérateurs réseau et relais traitent selon leurs politiques. Vous contrôlez les permissions navigateur/OS.

9. Services tiers

Google/Firebase ; paiements via processeurs avec leurs propres conditions. Les aperçus de liens peuvent solliciter des sites tiers.

10. Propriété intellectuelle

La marque et le logiciel Duvpost (sauf votre contenu) sont protégés.

11. Exclusion de garanties

Le Service est fourni « tel quel » et « selon disponibilité ». Dans toute la mesure permise par la loi, nous excluons toutes garanties expresses, implicites ou légales, y compris qualité marchande, adéquation à un usage particulier, jouissance paisible et non-violation.

Nous ne garantissons pas un fonctionnement ininterrompu ou sans erreur, la correction des défauts, l'absence de composants nuisibles sur nos serveurs ni que les données ne seront jamais perdues, corrompues ou divulguées. Le Service n'est pas une archive de sauvegarde, ne remplace pas des conseils médicaux, juridiques ou financiers professionnels, n'est pas un service d'urgence ni un système d'enregistrement pour obligations légales ou réglementaires sauf accord écrit explicite.

Nous ne sommes pas responsables de l'exactitude, la légalité ou la qualité du contenu envoyé par d'autres utilisateurs. Votre utilisation du Service et votre confiance en tout contenu sont à vos seuls risques.

12. Limitation de responsabilité

Dans la mesure permise par la loi, nous, nos fournisseurs, dirigeants et personnel ne serons pas responsables de dommages indirects, accessoires, spéciaux, consécutifs ou punitifs, ni de perte de profits, de chiffre d'affaires, de données, de goodwill ou d'opportunités, même si la possibilité de tels dommages a été signalée.

Notre responsabilité globale pour toute réclamation liée au Service ou aux présentes conditions est limitée au plus élevé de (a) ce que vous avez payé pour le Service dans les douze (12) mois précédant la réclamation ou (b) 50 EUR en l'absence de paiements. Ces limitations s'appliquent quelle que soit la base juridique (contrat, délit y compris négligence, responsabilité stricte), sauf lorsque la loi l'interdit (p. ex. décès ou lésions corporelles dues à notre négligence, fraude).

Si certaines limitations ne sont pas valables dans votre juridiction, notre responsabilité est limitée au maximum permis par la loi.

13. Indemnisation

Vous nous indemnisez pour réclamations, dommages, pertes et honoraires juridiques raisonnables découlant de votre utilisation, votre contenu ou votre manquement, sauf faute intentionnelle de notre part.

14. Résiliation

Vous pouvez cesser d'utiliser à tout moment ; nous pouvons suspendre en cas de manquement, risque de sécurité, impayé ou exigences légales. Les dispositions devant survivre par nature (limites de responsabilité, indemnisation, droit applicable) survivent.

15. Modifications

Nous pouvons mettre à jour ces conditions et la date « Dernière mise à jour ». Les changements importants peuvent exiger un avis ou un consentement supplémentaire selon la loi. L'utilisation continue après l'entrée en vigueur vaut acceptation sauf exigence contraire de la loi.

16. Droit applicable et litiges

Les présentes conditions sont régies par les lois du pays où l'exploitant du Service a son siège social ou son établissement principal, sans préjudice des dispositions impératives de protection des consommateurs qui vous sont applicables dans votre pays de résidence habituelle.

Si vous êtes consommateur résidant habituellement dans l'Espace économique européen, vous pouvez vous prévaloir des dispositions impératives du droit de votre pays de résidence lorsque la loi le prévoit, et intenter une action contre nous devant les tribunaux de votre lieu de résidence lorsque la loi l'exige. Nous pouvons intenter une action contre vous devant les tribunaux de notre établissement ou, le cas échéant, dans votre pays de résidence.

17. Dispositions diverses

Si une disposition est invalide, les autres demeurent en vigueur. Les présentes conditions, avec la Politique de confidentialité et les conditions spécifiques à l'offre présentées à l'achat, constituent l'intégralité de l'accord. Vous ne pouvez pas céder vos droits sans notre consentement ; nous pouvons céder en cas de fusion, acquisition ou vente d'actifs. Le défaut d'exercer un droit n'est pas une renonciation. Nous ne sommes pas responsables des retards ou défaillances dus à des événements hors de notre contrôle raisonnable (force majeure).

18. Contact

Questions sur ces conditions : exploitant selon les coordonnées publiées dans l'application (p. ex. About) ou sur le site.

Dernière mise à jour : mars 2026`,

  privacyFull: `1. Introduction

Cette Politique de confidentialité décrit le traitement des données personnelles lors de l'utilisation de Duvpost. Complète les conditions d'utilisation.

Le Service est exploité à petite échelle ; les fonctionnalités peuvent évoluer (groupes, chaînes, appels de groupe, offres payantes, modération). La politique décrit le traitement aligné sur le produit déployé et son évolution raisonnablement prévisible.

2. Responsable

L'exploitant de votre déploiement Duvpost, indiqué dans l'application (p. ex. About) ou sur le domaine. Pour les demandes, utilisez les coordonnées publiées.

3. Données traitées

Selon l'utilisation : compte/authentification ; profil/découverte (People) ; messages (aujourd'hui surtout 1:1 ; fils de groupe si ajoutés) ; chaînes si proposées ; pièces jointes avec limites et conservation selon l'offre ; appels/Meet y compris groupes si existants ; paiements/abonnements ; données techniques ; App Check/reCAPTCHA ; stockage local ; aperçus de liens. Nous n'utilisons pas le contenu des chats pour entraîner des modèles d'IA publics.

4. Finalités et bases légales

Exécution du contrat ; sécurité, quotas, conservation ; obligations légales ; e-mails transactionnels ; paiements. Consentement séparé pour marketing/cookies non essentiels si introduits.

5. Sous-traitants

Google Firebase et services Google associés ; liste et documentation actuelles : https://firebase.google.com/support/privacy et conditions de traitement des données Google Cloud/Firebase. Éventuellement processeurs de paiement, hébergement, e-mail.

6. Transferts internationaux

Comme d'usage avec Google/Firebase, p. ex. clauses contractuelles types.

7. Conservation

Les messages de discussion (stockés en chiffré dans Firestore) et les pièces jointes dans Storage sont conservés 14 jours à compter de leur création, puis supprimés automatiquement. Les données de compte, de profil et de contacts sont conservées tant que le compte est actif et nécessaire. Sauvegardes/journaux limités. Après suppression du compte, effacement ou anonymisation dans la mesure du possible ; données groupe/chaîne chez d'autres membres selon la logique produit.

8. Sécurité

HTTPS, règles, chiffrement côté client éventuel, App Check, en-têtes — voir documentation technique.

9. Violations de données personnelles

Si nous avons connaissance d'une violation de la sécurité entraînant destruction, perte, altération ou divulgation non autorisée de données personnelles sous notre contrôle, nous prendrons des mesures raisonnables pour atténuer le préjudice et, lorsque la loi l'exige, notifierons sans retard indu les autorités de contrôle et/ou les personnes concernées.

10. Vos droits

Selon votre lieu : accès, rectification, effacement, limitation, opposition, portabilité, réclamation auprès d'une autorité.

11. Décisions automatisées

Nous n'utilisons pas vos données personnelles pour des décisions fondées exclusivement sur un traitement automatisé produisant des effets juridiques ou vous affectant de manière significative de façon similaire, sauf notification contraire avec base légale.

12. Mineurs

Pas en dessous de l'âge minimum des conditions.

13. Cookies

Essentiels pour connexion/session ; autres uniquement avec information et, le cas échéant, consentiment.

14. Modifications

Nous pouvons mettre à jour cette politique.

15. Contact

Demandes vie privée à l'exploitant selon coordonnées publiées.

Dernière mise à jour : mars 2026`,
} as const;
